 namespace Areas.Building.Edit {
    "use strict";

    var tabItems = Areas.createTabsWithSameAction("Building", "Edit",
        ["Profile", "BuildingImage", "Project", "Drawing",
         "Permit", "AutoCad", "Picture", 
        "Presentation", "OtherAttachment","AllAttachment"]);

    export function tabInitialized(params: any) {
        return Areas.tabWithIdInitialized(tabItems)(params);
    }

    export function newBuildingAlias(e: any) {
        setBuildingId("AliasDataGrid", e);
    }

    export function newBuildingProject(e: any) {
        setBuildingId("ProjectDataGrid", e);
    }

    function setBuildingId(gridName: string, e: any) {
        const dataGrid = $(`#${gridName}`).dxDataGrid("instance");
        const buildingId = dataGrid.option("buildingId");

        e.data.buildingId = buildingId;        
    }

}